import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Tree, Input, Col, Checkbox, Spin } from 'antd';
import { SearchOutlined, TagOutlined } from '@ant-design/icons';
import { isEqual, cloneDeep, debounce } from 'lodash';
import { callApi } from 'utils';
import { SelectContext } from '../context';
import singleSelectMode from '../utils/single-select-mode';

const prefixClx = 'select-modal-new';
const TreeNode = Tree.TreeNode;
class SelectLabel extends PureComponent {
	static contextType = SelectContext;
	constructor (props) {
		super(props);
		this.state = {
			loading: false,
			expandedKeys: [],
			selectedKeys: props.selects.filter(val => val.flowUserSelectionType === 'label').map(val => String(val.sourceIdA)),
			disabledObj: this.getDisabledObj(props.disabledSelects),
			labelGroups: [],
		};
	}

	componentDidMount () {
		const { organizations } = this.props;
		if (organizations) {
			this.initTree(this.props);
		}
	}

	componentWillReceiveProps (nextProps) {
		const { organizations } = this.props;
		const { selects } = nextProps;
		if (organizations !== nextProps.organizations && nextProps.organizations) {
			this.initTree(nextProps);
		}
		if (!isEqual(this.props.selects, selects)) {
			this.setState({
				selectedKeys: selects.filter(val => val.flowUserSelectionType === 'label').map(val => String(val.sourceIdA))
			});
		}
	}

	//封装不可选择列表
	getDisabledObj = (disabledList = []) => {
		const obj = {};
		disabledList.filter(val => val.flowUserSelectionType === 'label').forEach(val => {
			obj[Number(val.sourceIdA)] || (obj[Number(val.sourceIdA)] = true);
		});
		return obj;
	}

	/**
	 * 初始化所有部门
	 */
	initTree = (props) => {
		const { organizations } = props;
		const { manageSceneFlag } = this.context;
		const id = organizations.id;
		callApi({
			api: '/org_v6/listLabelsByComponent',
			data: { organizationId: id, manageSceneFlag },
			success: (labelGroups = []) => {
				this.setState({
					labelGroups: labelGroups,
					expandedKeys: labelGroups.map(obj => (String(obj.id)) + 'group'),
				});
			}
		});
	}

	// 改变某个组的全选
	changeGroupSelectAll = (currentNode, selectedAll) => {
		const { selects, addItems, removeItems } = this.props;
		const { labels } = currentNode;
		const transToSource = nodeList => nodeList.map(nodeItem => ({
			selectionName: nodeItem.name,
			flowUserSelectionType: 'label',
			sourceIdA: nodeItem.id,
			sourceTypeA: 'source_label',
		}));
		if (selectedAll) {
			// 找出已选中的，并删除
			const removeList = labels.filter(item => {
				return selects.some(node => node.sourceIdA === item.id && node.sourceTypeA === 'source_label');
			});
			removeItems(transToSource(removeList));
		} else {
			// 找出还未选中的，并添加
			const addList = labels.filter(item => {
				return !selects.some(node => node.sourceIdA === item.targetId && node.sourceTypeA === 'source_label');
			});
			addItems(transToSource(addList));
		}
	}

	/**
	 * 生成部门组织树状数据结构
	 */
	generateNodes = (list) => {
		const { disabledObj } = this.state;
		const { selects } = this.props;
		// 整个组是否全选
		const validateSelectedAll = (curNodeList = []) => {
			const validateResult = curNodeList.every(curNode => {
				const { labels = [] } = curNode;
				const pureLabelList = labels.filter(labelItem => labelItem.groupId);
				const currentSetsFlag = pureLabelList.every(pureLabelItem => selects.some(selectNode => selectNode.sourceIdA === pureLabelItem.id));
				return currentSetsFlag;
			});
			return validateResult;
		};
		return list.map(node => {
			const { labels, name, id, selectedFlag, groupId } = node;
			const selectedAll = validateSelectedAll([node]);
			if (labels) {
				const isSingleSelectMode = singleSelectMode({
					context: this.context
				});
				return <TreeNode
					disabled={disabledObj[id] || selectedFlag === 0 || labels.length === 0}
					selectable={false}
					allData={node}
					key={String(id) + 'group'}
					title={<div className={`${prefixClx}-node`}>
						<span className={`${prefixClx}-node-name`}>
							{name}
						</span>
						{/*单选模式去掉全选*/}
						{(isSingleSelectMode || disabledObj[id] || selectedFlag === 0 || labels.length === 0)
							? null
							: <span className={`${prefixClx}-node-handle select-all`} onClick={() => this.changeGroupSelectAll(node, selectedAll)}>{selectedAll ? '取消全选' : '全选'}</span>
						}</div>}
				>
					{this.generateNodes(labels)}
				</TreeNode>;
			}
			const selected = (() => {
				if (!groupId) {
					return false;
				}
				return selects.some(selectNode => selectNode.sourceIdA === id && selectNode.sourceTypeA === 'source_label');
			})();
			return <TreeNode disabled={disabledObj[id] || selectedFlag === 0 || !groupId} allData={node} key={String(id)}
				title={node.groupId
					? <div className={`${prefixClx}-node`}>
						<span className={`${prefixClx}-node-name`}>
							<TagOutlined className='type-icon' />
							{name}
						</span>
						<span className={`${prefixClx}-node-handle`}>
							<Checkbox disabled={disabledObj[id] || selectedFlag === 0 || !groupId} checked={selected} />
						</span>
					</div>
					: name} />;
		});
	}

	// 选择标签
	onSelect = (selectedKeys, { selectedNodes, node, selected }) => {
		const { props } = this;
		let newSelect = [];
		if (Array.isArray(selectedNodes)) {
			newSelect = selectedNodes.filter(val => val.allData.groupId).map(val => ({
				selectionName: val.allData.name,
				flowUserSelectionType: 'label',
				sourceIdA: val.allData.id,
				sourceTypeA: 'source_label',
			}));
			if (selected) {
				props.addItems(newSelect);
			} else {
				props.removeItems(this.getlabelItems(node.allData));
			}
		}
		this.setState({ selectedKeys: selectedKeys });
	}

	//获取标签
	getlabelItems = data => {
		const { labelGroups } = this.state;
		if (data.groupId) {
			return [{
				selectionName: data.name,
				flowUserSelectionType: 'label',
				sourceIdA: data.id,
				sourceTypeA: 'source_label',
			}];
		}
		for (const i in labelGroups) {
			const val = labelGroups[i];
			if (val.id === Number(data.id) && val.labels) {
				return val.labels.map(obj => ({
					selectionName: obj.name,
					flowUserSelectionType: 'label',
					sourceIdA: obj.id,
					sourceTypeA: 'source_label',
				}));
			}
		}
	}

	/**
	 * 点击展开/收缩树节点
	 */
	onExpand = (keys, info) => {
		this.setState({ expandedKeys: keys });
	}

	/**
	 * 生成搜索结果数据结构
	 */
	generateList = list => {
		const { selects } = this.props;
		const { disabledObj } = this.state;
		return list.map(node => {
			const { name, id, selectedFlag, groupId } = node;
			const selected = (() => {
				if (!groupId) {
					return false;
				}
				return selects.some(selectNode => selectNode.sourceIdA === id && selectNode.sourceTypeA === 'source_label');
			})();
			return <TreeNode disabled={disabledObj[id] || selectedFlag === 0} allData={node} key={String(id)}
				title={<div className={`${prefixClx}-node`}>
					<span className={`${prefixClx}-node-name`}>
						<TagOutlined className='type-icon' />
						{name}
					</span>
					<span className={`${prefixClx}-node-handle`}>
						<Checkbox disabled={disabledObj[id] || selectedFlag === 0 || !groupId} checked={selected} />
					</span>
				</div>}
			/>;
		});
	};

	/**
	 * 根据关键字搜索
	 */
	searchByKeywords = (keywords = '') => {
		let searchList = [];
		keywords = keywords.trim();
		const { labelGroups = [] } = this.state;
		if (!keywords) {
			this.setState({
				searchList: [],
				showSearchBox: true,
				searchText: keywords,
			});
		} else {
			labelGroups.forEach(({ labels = [] }) => {
				searchList = searchList.concat(labels.filter(({ name = '' }) => name.indexOf(keywords) > -1));
			});
			this.setState({
				loading: true,
				searchList,
				showSearchBox: true,
				searchText: keywords,
			}, () => {
				this.setState({
					loading: false,
				});
			});
		}
	}

	// 防抖
	searchByKeywordsDebounced = debounce(this.searchByKeywords, 500);

	render () {
		const { loading, expandedKeys, selectedKeys, searchText, searchList = [], showSearchBox, labelGroups } = this.state;
		return (
			<Col className='tree-box select-checkbox'>
				<div className='select-box-search'>
					<Input
						placeholder="请输入标签"
						onChange={(e) => this.searchByKeywordsDebounced(e.target.value)}
						prefix={<SearchOutlined />}
						allowClear
					/>
				</div>
				<div className={'select-scroll-view'}>
					{showSearchBox && searchText
						? searchList.length < 1
							? <div className='tree-box-center'>未找到相关结果</div>
							: <Tree
								multiple
								selectedKeys={cloneDeep(selectedKeys)}
								onSelect={this.onSelect}
								selectable
							>
								{this.generateList(searchList)}
							</Tree>
						: loading ? <Spin className='tree-box-center' /> : <Tree
							multiple
							expandedKeys={cloneDeep(expandedKeys)}
							selectedKeys={cloneDeep(selectedKeys)}
							onExpand={this.onExpand}
							onSelect={this.onSelect}
							selectable
						>
							{this.generateNodes(labelGroups)}
						</Tree>
					}
				</div>
			</Col>
		);
	}
}

SelectLabel.propTypes = {
	organizations: PropTypes.object.isRequired, // 组织架构数据
	// 选中的列表， 数据结构为 [{selectionName: 显示名称, flowUserSelectionType: 'department', sourceIdA: ID, sourceTypeA: 'source_department'}]

	/* 以下是configs额外传进来的参数 */
	useDisable: PropTypes.bool,
	disabledSelects: PropTypes.array.isRequired,
	selects: PropTypes.array.isRequired,
	// 是否支持选择 '包含子部门'
	selectChild: PropTypes.bool,
	addItems: PropTypes.func.isRequired,		// 选中一个条目的回调
	removeItems: PropTypes.func.isRequired,		// 祛选中一个条目的回调
};
export default SelectLabel;
